import { ChangeDetectorRef, Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FuseNavigationItem } from '@fuse/types';
import { LocalAccountService } from 'app/main/shared/services/localAccount.service';
import { merge, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
    selector: 'fuse-nav-vertical-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss']
})
export class FuseNavVerticalItemComponent implements OnInit, OnDestroy {
    @HostBinding('class')
    classes = 'nav-item';

    @Input()
    item: FuseNavigationItem;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     */

    /**
     *
     * @param {ChangeDetectorRef} _changeDetectorRef
     * @param {FuseNavigationService} _fuseNavigationService
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _fuseNavigationService: FuseNavigationService,
        private iconRegistry: MatIconRegistry,
        private sanitizer: DomSanitizer,
        private localAccountService: LocalAccountService
    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.iconRegistry.addSvgIcon(
            'bank',
            this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/images/bank-building.svg')
        );
        this.iconRegistry.addSvgIcon(
            'fields-icon',
            this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/images/note.svg')
        );
        this.iconRegistry.addSvgIcon(
            'customtimer',
            this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/images/stop-watch.svg')
        );
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit() {
        // Subscribe to navigation item
        merge(
            this._fuseNavigationService.onNavigationItemAdded,
            this._fuseNavigationService.onNavigationItemUpdated,
            this._fuseNavigationService.onNavigationItemRemoved
        ).pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }


    check(item) {
        if (item.checkAdministratorOrOperator) {
            return this.localAccountService.isAdmin() || this.localAccountService.isOperator();
        } else if (item.checkAdministrator) {
            return this.localAccountService.isAdmin();
        } else if (item.checkOperator) {
            return this.localAccountService.isOperator();
        } if (item.checkStudentOrProfessor) {
            return this.localAccountService.isStudent() || this.localAccountService.isProfessor();
        } else if (item.checkStudent) {
            return this.localAccountService.isStudent();
        } else if (item.checkProfessor) {
            return this.localAccountService.isProfessor();
        } else if (item.checkCompany) {
            return this.localAccountService.isCompany();
        } else {
            return true;
        }
    }
}
